import React, { forwardRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container, Dialog, IconButton, Slide, useMediaQuery } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Close } from '@material-ui/icons'

import {
  setCurrentStep,
  updateUserProgressStart,
  sendTextMessageStart,
  setSuccess,
} from '../../redux/modules/onboarding'
import { pushSnowplow, toUserUnboardingProcessSchema } from '../../util/snowplow'
import {
  CLICKED_CLOSE_DIALOG,
  CLICKED_COMPLETE_ONBOARDING,
} from '../../util/events/onboardingEvents'
import { ONBOARDING_STEPS, setHideOnboarding } from './onboardingUtils'
import StepEmailSendTime from './StepEmailSendTime'
import StepCuisineTypes from './StepCuisineTypes'
import StepMobileDownload from './StepMobileDownload'

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  container: {
    paddingTop: theme.spacing(5),
    maxWidth: '720px',
  },
}))

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DialogOnboarding = ({
  onClose,
  userProgress,
  currentUser,
  currentStep,
  setCurrentStep,
  successOnboarding,
  errorSendingTextMessage,
  errorUpdatingUserProgress,
  isSendingTextMessage,
  updateUserProgressStart,
  sendTextMessageStart,
  setSuccess,
}) => {
  const classes = useStyles()
  const showSnackbar = useMediaQuery('(min-height:730px)')
  const errorOnboarding = errorSendingTextMessage || errorUpdatingUserProgress

  const handleClose = () => {
    pushSnowplow(toUserUnboardingProcessSchema(CLICKED_CLOSE_DIALOG, currentStep?.name))
    onClose()
  }

  useEffect(() => {
    if (successOnboarding && !errorOnboarding) {
      setCurrentStep(ONBOARDING_STEPS.COMPLETE)
      setHideOnboarding(currentUser.userId)
      onClose()
    }
    if (errorOnboarding) {
      pushSnowplow(
        toUserUnboardingProcessSchema(
          CLICKED_COMPLETE_ONBOARDING,
          currentStep?.name,
          null,
          errorOnboarding,
        ),
      )
    }
    //eslint-disable-next-line
  }, [successOnboarding, errorOnboarding])

  return (
    <Dialog open fullScreen TransitionComponent={Transition}>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <Close />
      </IconButton>
      <Container className={classes.container}>
        {currentStep?.value === ONBOARDING_STEPS.EMAIL_SEND_TIME.value && (
          <StepEmailSendTime
            setCurrentStep={setCurrentStep}
            updateUserProgressStart={updateUserProgressStart}
            showSnackbar={showSnackbar}
          />
        )}
        {currentStep?.value === ONBOARDING_STEPS.CUISINE_TYPES.value && (
          <StepCuisineTypes
            setCurrentStep={setCurrentStep}
            updateUserProgressStart={updateUserProgressStart}
            showSnackbar={showSnackbar}
            hasMobileApp={userProgress?.hasMobileApp}
            setSuccess={setSuccess}
          />
        )}
        {currentStep?.value === ONBOARDING_STEPS.MOBILE_DOWNLOAD.value && (
          <StepMobileDownload
            onSubmit={sendTextMessageStart}
            error={errorSendingTextMessage}
            submitting={isSendingTextMessage}
            showSnackbar={showSnackbar}
            setSuccess={setSuccess}
          />
        )}
      </Container>
    </Dialog>
  )
}

const mapStateToProps = state => {
  const { currentUser } = state.user
  const {
    userProgress,
    currentStep,
    successOnboarding,
    errorSendingTextMessage,
    errorUpdatingUserProgress,
    isSendingTextMessage,
  } = state.onboarding

  return {
    userProgress,
    currentUser,
    currentStep,
    successOnboarding,
    errorSendingTextMessage,
    errorUpdatingUserProgress,
    isSendingTextMessage,
  }
}

const mapDispatchToProps = {
  setCurrentStep,
  updateUserProgressStart,
  sendTextMessageStart,
  setSuccess,
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogOnboarding)
